export const formatCurrency = (num) => {
  if (!num) {
    num = 0;
  }
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};
